import { property, curry } from 'lodash-es';
import { compose } from 'redux';

export const propFromSelector = curry((selector, prop, state) =>
  compose(
    property(prop),
    selector
  )(state)
);
